// extracted by mini-css-extract-plugin
export default {"top":"style_top__WQtv6","profile":"style_profile__Y0+jM","image":"style_image__IiCHr","name":"style_name__0GknL","Shouts":"style_Shouts__HPHsl","options":"style_options__URKer"};